import { createFeature, createReducer, on } from '@ngrx/store';
import * as skuMetadataActions from './sku-metadata.actions';

export interface SkuMetadataState {
    lastUpdated: Date | undefined;
    version: string;
    failed: boolean,
    error: string,
}

export const skuMetadataFeatureKey = 'sku-metadata';

export const initialSkuMetadataState: SkuMetadataState = {
    lastUpdated: undefined,
    version: '',
    failed: false,
    error: '',
};

export const feature = createFeature({
    name: skuMetadataFeatureKey,
    reducer: createReducer(
        initialSkuMetadataState,
        on(skuMetadataActions.getSkuMetadataSuccess, (state, { lastUpdated, version }) => {
            return {
                ...state,
                lastUpdated,
                version,
                failed: false,
                error: '',
            };
        }),
        on(skuMetadataActions.getSkuMetadataFailure, (state, { error }) => {
            return {
                ...state,
                failed: true,
                error: error.message,
            };
        })
    ),
});
